import { Box } from '@chakra-ui/react';
import { ErrorMessage, Field, useFormikContext } from 'formik';
import React from 'react';

function InputFormikSemLabel({
  titulo,
  gridColumn,
  component,
  autocomplete = false,
  ...rest
}) {
  const formik = useFormikContext();

  if (autocomplete) {
    return (
      <Box gridColumn={gridColumn}>
        <Field as={component} onSourceSelect={formik.setFieldValue} {...rest} />
        <ErrorMessage name={rest.name} />
      </Box>
    );
  }
  return (
    <Box gridColumn={gridColumn}>
      <Field as={component} {...rest} />
      <ErrorMessage name={rest.name} />
    </Box>
  );
}

export default InputFormikSemLabel;
